/* eslint-disable prettier/prettier */
/* eslint-disable import/named */
import '../../../styles/IncomingClaimPage.scss';
import { Button, Input } from 'reactstrap/lib';
import { DropdownOption } from '../new/typings';
import {
  FirebaseReducer,
  FirestoreReducer,
  ReduxFirestoreQueries,
  firestoreConnect,
  isLoaded,
} from 'react-redux-firebase';
import { IncomingPageState, OutgoingPageProps, OutgoingPageState } from '../typings';
import { Label, Table } from 'reactstrap';
import { RouteComponentProps } from 'react-router';
import { authorizedOptions, orderPaymentTodos } from '../../../helpers/utils';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { plus, search } from 'react-icons-kit/feather';
import EmptyState from '../../claims/empty-state/EmptyState';
import HeaderComponent from '../shared/table/HeaderComponent';
import Helmet from 'react-helmet';
import Icon from 'react-icons-kit';
import LoadingPage from '../../loading/LoadingPage';
import OutgoingRow from '../shared/table/OutgoingRow';
import OutgoingSidePanel from '../side-panel/OutgoingSidePanel';
import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

const statusOptions = ['STATUS', 'NEW', 'INVOICED', 'SERVICE DONE', 'BOOKED', 'EXCESS_COLLECTED', 'ACCEPTED', 'CANCELLED']; // , 'COMPLETED'

class OutgoingClaimPage extends Component<
  RouteComponentProps & FirebaseReducer.Reducer & OutgoingPageProps,
  OutgoingPageState
> {
  private static INITIAL_STATE: Pick<IncomingPageState, 'activeClaim'> = {
    activeClaim: null,
  };

  private static propKey(propertyName: string, value: any): object {
    return { [propertyName]: value };
  }

  private setStateWithEvent(event: any, columnType: string): void {
    this.setState(OutgoingClaimPage.propKey(columnType, (event.target as any).value));
  }

  constructor(props: any) {
    super(props);
    this.state = {
      ...OutgoingClaimPage.INITIAL_STATE,
      statusFilter: { value: 'STATUS', label: 'ALL' },
      authorizedFilter: { value: 'Both', label: 'Both' },
      partnerFilter: { value: 'Partner', label: 'Destination Member' },
      countryFilter: { value: 'Country', label: 'Country' },
      searchStringVal: '',
      popoverOpen: false,
      sortCreatedByFilter: 'desc' as 'asc' | 'desc',
      sortUpdatedByFilter: 'desc' as 'asc' | 'desc',
      sortBy: null,
    };

    props.searchChange('');
  }

  public selectClaim(id: string | null) {
    this.setState(OutgoingClaimPage.propKey('activeClaim', id));
  }

  options = statusOptions.map((status: string) => {
    if (status === 'STATUS') {
      return {
        value: status,
        label: 'ALL',
      };
    }
    return {
      value: status,
      label: status,
    };
  });

  authorizedOpts = authorizedOptions.map((status: string) => {
    return {
      value: status,
      label: status,
    };
  });

  setStatusFilter = (value: DropdownOption) => {
    this.setState({ statusFilter: value });
  };

  setAuthorizedFilter = (value: DropdownOption) => {
    this.setState({ authorizedFilter: value });
  };

  setPartnersFilter = (value: DropdownOption) => {
    this.setState({ partnerFilter: value });
  };

  setCountryFilter = (value: DropdownOption) => {
    this.setState({ countryFilter: value });
  };

  onSearchBtnClick = () => {
    const searchValue = (this.state.searchStringVal || '').trim();

    if (searchValue.length === 0) {
      typeof this.props.searchChange === 'function' && this.props.searchChange('');
      return;
    }

    if (searchValue.length < 3) {
      return;
    }

    typeof this.props.searchChange === 'function' && this.props.searchChange(searchValue);
  };

  onSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchStringVal = event.target.value;
    this.setState({ searchStringVal });

    if (searchStringVal.trim().length === 0) {
      typeof this.props.searchChange === 'function' && this.props.searchChange('');
    }
  };

  onSearchInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      this.onSearchBtnClick();
    }
  };

  onResetSearchBtnClick = () => {
    this.setState({ searchStringVal: '' });
    typeof this.props.searchChange === 'function' && this.props.searchChange('');
  };

  onNewClaimBtnClick = () => {
    this.props.history.push('/new-claim');
  };

  openClaimFromRoute = (props: any = this.props) => {
    const activeClaimId = props?.location?.state?.activeClaimId;
    if (activeClaimId && this.state.activeClaim !== activeClaimId) {
      this.selectClaim(activeClaimId);
    }
  };

  componentDidMount() {
    this.openClaimFromRoute();
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.location !== this.props.location) {
      this.openClaimFromRoute();
    }

    const { claims } = this.props;
    const { activeClaim } = this.state;
    if (activeClaim && claims && !claims[activeClaim]) {
      this.selectClaim(null);
    }
  }

  setSortCreatedByFilter = ()=>{
    console.log('sortCreatedByFilter', this.state.sortCreatedByFilter);
    this.state.sortCreatedByFilter === 'asc'
      ? this.setState({ sortCreatedByFilter: 'desc', sortBy: 'created' })
      : this.setState({ sortCreatedByFilter: 'asc', sortBy: 'created' });
  };

  setSortUpdatedByFilter = ()=>{
    console.log('sortUpdatedByFilter', this.state.sortUpdatedByFilter);
    this.state.sortUpdatedByFilter === 'asc'
      ? this.setState({ sortUpdatedByFilter: 'desc', sortBy: 'updated' })
      : this.setState({ sortUpdatedByFilter: 'asc', sortBy: 'updated' });
  };

  render() {
    const { claims, loading, partner, todos, partnerOptions, partners, countryOptions, dateRangeValue, } = this.props;
    const { activeClaim, searchStringVal } = this.state;
    const trimmedSearchValue = (searchStringVal || '').trim();
    const canTriggerSearch = trimmedSearchValue.length >= 3 || trimmedSearchValue.length === 0;
    const claim =
      claims && activeClaim && claims[activeClaim]
        ? { ...claims[activeClaim], id: activeClaim }
        : null;
    if (loading) {
      return <LoadingPage />;
    }
    
    if (_.isEmpty(claims)) {
      return (
        <EmptyState
          message={
            searchStringVal !== '' || dateRangeValue.search
              ? 'No claims match your search'
              : 'There are currently no claims in the system'
          }
        />
      );
    }

    let claimsList = _.pickBy(claims, (c) => {
      if (this.state.authorizedFilter.value === 'Authorized') {
        return c.insurer.authorized === true;
      } else if (this.state.authorizedFilter.value === 'Unauthorized') {
        return c.insurer.authorized === false;
      }
      return c;
    });

    claimsList = _.pickBy(claimsList, (c) => {
      if (this.state.statusFilter.value !== 'STATUS') {
        return c.status === this.state.statusFilter.value;
      }
      return c;
    });

    claimsList = _.pickBy(claimsList, (c) => {
      if (this.state.partnerFilter.value !== 'Partner') {
        return c.assign.partner === this.state.partnerFilter.value;
      }
      return c;
    });

    claimsList = _.pickBy(claimsList, (c) => {
      if (this.state.countryFilter.value !== 'Country') {
        return partners[c.assign.partner || '']?.country === this.state.countryFilter.value;
      }
      return c;
    });

    let sortedClaimsList;

    if (this.state.sortBy === 'created') {
        sortedClaimsList = this.state.sortCreatedByFilter === 'asc'
            ? _.sortBy(Object.values(claimsList), (c) => c._audit.created.timestamp)
            : _.sortBy(Object.values(claimsList), (c) => c._audit.created.timestamp).reverse();
    } else if (this.state.sortBy === 'updated') {
        sortedClaimsList = this.state.sortUpdatedByFilter === 'asc'
            ? _.sortBy(Object.values(claimsList), (c) => c._audit.updated.timestamp)
            : _.sortBy(Object.values(claimsList), (c) => c._audit.updated.timestamp).reverse();
    } else {
        sortedClaimsList = Object.values(claimsList);
    }
    
    // Add IDs to claim objects
    const claimsWithIds = _.map(sortedClaimsList, (c) => {
      const id = _.findKey(claimsList, (claim) => claim === c);
      return { ...c, id };
    });

    return (
      <div className={`incoming-claim-page-container outgoing-claim-page-container ${activeClaim ? 'open' : 'closed'}`}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>AGE | Claims Sent</title>
        </Helmet>
        <div className="page-header">
          <div className="page-title-div">
            <Label>Claims Sent</Label>
          </div>

          <div className="top-controls">
            {/* <Button className="new-claim-top-btn" onClick={this.onNewClaimBtnClick}>
              <Icon icon={plus} size={24} />
              <span>New Claim</span>
            </Button> */}

            <div className="search-control">
              <button
                type="button"
                className="search-icon-btn"
                onClick={this.onSearchBtnClick}
                disabled={!canTriggerSearch}
                aria-label="Search claims">
                <Icon icon={search} size={22} />
              </button>
              <Input
                name="search"
                value={this.state.searchStringVal}
                placeholder=""
                className="search-input"
                onChange={this.onSearchInputChange}
                onKeyDown={this.onSearchInputKeyDown}
              />
            </div>
          </div>
        </div>
        <Table>
          <HeaderComponent
            statusFilter={this.state.statusFilter}
            setStatusFilter={this.setStatusFilter}
            options={this.options}
            partnerOptions={partnerOptions}
            partnerFilter={this.state.partnerFilter}
            setPartnersFilter={this.setPartnersFilter}
            queue="Destination"
            authorizedOptions={this.authorizedOpts}
            authorizedFilter={this.state.authorizedFilter}
            setAuthorizedFilter={this.setAuthorizedFilter}
            countryOptions={countryOptions}
            countryFilter={this.state.countryFilter}
            setCountryFilter={this.setCountryFilter}
            setSortCreatedByFilter={this.setSortCreatedByFilter}
            sortCreatedByFilter={this.state.sortCreatedByFilter}
            setSortUpdatedByFilter={this.setSortUpdatedByFilter}
            sortUpdatedByFilter={this.state.sortUpdatedByFilter}
          />
          <tbody>
            {_.map(claimsWithIds, (c) => (
              <OutgoingRow
                key={`outgoing-row-${c.id}`}
                claim={c}
                partners={partners} 
                onClick={() => this.selectClaim(c.id || null)}/>
            ))}
          </tbody>
        </Table>
        <OutgoingSidePanel
          claim={claim}
          todos={todos}
          partner={partner}
          onClose={() => this.selectClaim(null)}
        />
      </div>
    );
  }
}

const preMapStateToProps = (state: any) => {
  const {
    firebase: { profile },
    searchString,
    dateRangeValue,
  }: { 
    firebase: FirebaseReducer.Reducer;
    searchString: { searchString: string }; 
    dateRangeValue: { toDate: string; fromDate: string; search: boolean };
  } = state;
  return {
    profile: profile,
    searchString,
    dateRangeValue,
  };
};

const mapQueryToProps = ({ 
  profile, 
  searchString, 
  dateRangeValue,
  firestore,
}: { 
  searchString: { searchString: string }, 
  dateRangeValue: { toDate: string; fromDate: string; search: boolean };
  firestore: FirestoreReducer.Reducer;
  profile: any 
}): ReduxFirestoreQueries => {
  if (!profile.isLoaded || profile.isEmpty) {
    return [];
  }
  let fromDate = moment('2000-01-01').toDate();
  let toDate = moment('2100-01-01').toDate();
  if (dateRangeValue.search) {
    fromDate = new Date(dateRangeValue.fromDate);
    toDate = new Date(dateRangeValue.toDate);
  }
  fromDate = firestore.Timestamp.fromDate(fromDate);
  toDate = firestore.Timestamp.fromDate(toDate);
  if (searchString.searchString === '') {
  return [
    {
      collection: 'claims',
      where: [
        ['assign.origin', '==', profile.partnerId],
        ['status', 'in', ['NEW', 'CONTACTED', 'BOOKED', 'EXCESS_COLLECTED','SERVICE DONE', 'ACCEPTED', 'INVOICED', 'CANCELLED']], // ['active', '==', true],
        ['_audit.created.timestamp', '>=', fromDate],
        ['_audit.created.timestamp', '<=', toDate],
      ],
      // limit: pagination.take,
      orderBy: ['_audit.created.timestamp', 'desc'],
    },
    {
      collection: 'config',
      doc: 'todos',
      storeAs: 'todosConfig',
    },
    {
      collection: 'partners',
      doc: profile.partnerId,
      storeAs: 'partner',
    },
    {
      collection: 'partners',
      storeAs: 'partners',
    },
  ];
} else {
  return [
    {
      collection: 'claims',
      where: [
        ['assign.origin', '==', profile.partnerId],
        ['status', 'in', ['NEW', 'CONTACTED', 'BOOKED', 'EXCESS_COLLECTED','SERVICE DONE', 'ACCEPTED', 'INVOICED', 'CANCELLED']],
        ['insurer.claimNumber', '==', searchString.searchString],
      ],
      orderBy: ['_audit.created.timestamp', 'desc'],
      storeAs: 'claimsNumber',
    },
    {
      collection: 'claims',
      where: [
        ['assign.origin', '==', profile.partnerId],
        ['vehicle.registrationNumber', '==', searchString.searchString],
      ],
      orderBy: ['_audit.created.timestamp', 'desc'],
      storeAs: 'claimsReg',
    },
    {
      collection: 'config',
      doc: 'todos',
      storeAs: 'todosConfig',
    },
    {
      collection: 'partners',
      doc: profile.partnerId,
      storeAs: 'partner',
    },
    {
      collection: 'partners',
      storeAs: 'partners',
    },
  ];
}
};

const mapDispatchToProps = (dispatch: any) => ({
  searchChange: (searchVal: string) => {
    dispatch({
      type: 'SEARCH_CHANGE',
      value: searchVal,
    });
  },
  setToDateValue: (toDateValue: string) => {
    dispatch({
      type: 'SET_TO_DATE_VALUE',
      value: toDateValue,
    });
  },
  setFromDateValue: (fromDateValue: string) => {
    dispatch({
      type: 'SET_FROM_DATE_VALUE',
      value: fromDateValue,
    });
  },
  searchDateRange: (value: boolean) => {
    dispatch({
      type: 'SEARCH_DATE_RANGE',
      value: value,
    });
  },
});

const mapStateToProps = (state: any) => {
  const {
    firestore,
    firebase: { auth },
    searchString,
    dateRangeValue,
    pagination,
  }: {
    firestore: FirestoreReducer.Reducer;
    firebase: FirebaseReducer.Reducer;
    pagination: { skip: number; take: number };
    searchString: { searchString: string };
    dateRangeValue: { toDate: string; fromDate: string; search: boolean };
  } = state;
  const partner = firestore.data.partner;
  const partners = firestore.data.partners;
  // const partnersList = firestore.data.partners;
  // const partnersData = firestore.data.partners;
  const partnerOptions: Array<{ value: string; label: string }> = [];
  const countryOptions: Array<{ value: string; label: string }> = [];
  _.map(partners, (partner, id) => {
    partnerOptions.push({ value: id, label: partner.name });
    countryOptions.push({ value: partner.country, label: partner.country });
  });
  partnerOptions.push({ value: 'Partner', label: 'Destination Member' });
  countryOptions.push({ value: 'Country', label: 'Country' });
  let claims = firestore.data.claims;
  if (searchString.searchString !== '') {
    // Merge both search results
    const claimsNumber = firestore.data.claimsNumber || {};
    const claimsReg = firestore.data.claimsReg || {};
    claims = { ...claimsNumber, ...claimsReg };
  }
  const todosConfig = firestore.data.todosConfig;
  const loadingClaims = searchString.searchString !== '' 
    ? !isLoaded(firestore.data.claimsNumber) || !isLoaded(firestore.data.claimsReg)
    : !isLoaded(claims);
  const loading = loadingClaims || !isLoaded(todosConfig) || !isLoaded(partner);
  let todos = null;
  if (!loading) {
    const masterTodo = todosConfig.todos;
    const partnerConfig = partner.claimTemplate.todos;
    todos = orderPaymentTodos(_.assign({}, masterTodo, partnerConfig));
  }
  return {
    loading,
    claims,
    todos,
    partner,
    partners,
    pagination,
    auth: auth as FirebaseReducer.AuthState,
    // partnersList,
    partnerOptions,
    countryOptions,
    dateRangeValue,
  };
};

export default compose(
  connect(preMapStateToProps),
  firestoreConnect(mapQueryToProps),
  connect(mapStateToProps, mapDispatchToProps),
)(OutgoingClaimPage);
